import { createPathlookupGraphLink } from '@ipfabric/utils';
import type { ApiTablePageComponent } from 'components/ApiTablePage/ApiTablePageComponent';
import { ButtonLink } from 'components/Button/ButtonLink';
import { useLocale } from 'containers/App/LocaleContext';
import { useNotifications } from 'utils/hooks/useNotifications';

export const PathVerificationsApiTablePage: ApiTablePageComponent = ({
  renderApiTablePage,
}) => {
  const msg = useLocale();
  const { showNotification } = useNotifications();
  return (
    <>
      <div className='mb'>
        <ButtonLink
          {...createPathlookupGraphLink({
            sidePanelContentId: 'pathlookup',
          })}
          onClick={() => {
            showNotification({
              type: 'info',
              message: msg.canvasGraph.definePathNotification,
            });
          }}
          variant='secondary'
          icon='fa-plus'
          type='button'
        >
          {msg.apiTablePage.customPages.pathVerifications.btnAddPath}
        </ButtonLink>
      </div>
      {renderApiTablePage()}
    </>
  );
};
